/** Parse Amazon/order_total display strings. Never invent 0 for empty. */

export function parseOrderTotal(raw?: string | null): number | null {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  // Keep digits, signs, decimal point, and scientific notation only.
  // Put `-` at the end of the class so it is NOT a range (+-e swallowed commas).
  const n = Number(s.replace(/[^0-9.+\-eE]/g, ''));
  if (!Number.isFinite(n)) return null;
  return n;
}

export function pctChange(current: number | null, prior: number | null): number | null {
  if (current == null || prior == null) return null;
  if (prior === 0) return current === 0 ? 0 : null;
  return ((current - prior) / Math.abs(prior)) * 100;
}

export function trendFromPct(pct: number | null): 'up' | 'down' | 'flat' | 'na' {
  if (pct == null || !Number.isFinite(pct)) return 'na';
  if (pct > 2) return 'up';
  if (pct < -2) return 'down';
  return 'flat';
}

export function formatMoney(value: number | null, currency?: string): string {
  if (value == null) return 'Unavailable';
  const ccy = currency && currency.length === 3 ? currency : undefined;
  try {
    return new Intl.NumberFormat(undefined, {
      style: ccy ? 'currency' : 'decimal',
      currency: ccy,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
  }
}

export function formatPct(pct: number | null): string {
  if (pct == null || !Number.isFinite(pct)) return '—';
  const sign = pct > 0 ? '+' : '';
  return `${sign}${pct.toFixed(1)}%`;
}

export function formatInt(n: number | null): string {
  if (n == null) return 'Unavailable';
  return n.toLocaleString();
}
